class Photos {
    takenAllPhotos(allPhotos) {
        const photos = allPhotos;
        let takenAllPhotos = true;

        photos.forEach((item) => {
            const possuiBase64 = item.image_base64.includes("data:image/jpeg;base64");
            if (!possuiBase64) {
                takenAllPhotos = false;
            }
        });

        return takenAllPhotos;
    }
}

export default Photos;
